import React, { useState, useEffect } from 'react';
import { Typography, Collapse, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { storefrontApi, type FaqItem } from '@/apis/storefrontApi';
import styles from './index.module.less';

const { Title, Paragraph } = Typography;

const FAQ: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState<FaqItem[]>([]);

  useEffect(() => {
    storefrontApi
      .getFaq()
      .then(setList)
      .catch(() => setList([]))
      .finally(() => setLoading(false));
  }, [i18n.language]);

  if (loading) {
    return (
      <div className={styles.page}>
        <div className={styles.loadingWrap}>
          <Spin size="large" />
        </div>
      </div>
    );
  }

  const title = t('faq.title');
  const description = t('faq.description');

  return (
    <div className={styles.page}>
      <div className={styles.inner}>
        <Title level={2} className={styles.title}>
          {title}
        </Title>
        <Paragraph className={styles.desc}>{description}</Paragraph>

        <Collapse
          className={styles.collapse}
          items={list.map((item) => ({
            key: item.id,
            label: item.question,
            children: <Paragraph className={styles.answer}>{item.answer}</Paragraph>,
          }))}
        />
      </div>
    </div>
  );
};

export default FAQ;
